export const selectAlert = (state) => state.alert
